import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingHousesFilterContainer } from '../../../containers/NewbuildingHousesFilter';
import { getIsHousesFilterEnabled } from '../../../selectors/newbuildingHeader';
import { selectAggregatedOffers } from '../../../selectors/results';
import { SummarySection } from '../../components/Summary';
import { ModerateLinkButtonContainer } from '../ModerateButtonContainer';
import { SummaryHeaderContainer } from './containers/SummaryHeaderContainer';
import { SummaryMapViewButtonContainer } from './containers/SummaryMapViewButtonContainer';
import { SummarySortDropdownContainer } from './containers/SummarySortDropdownContainer';

export function SummaryContainer() {
  const isNewbuildingHousesFilterEnabled = useSelector(getIsHousesFilterEnabled);
  const aggregatedOffers = useSelector(selectAggregatedOffers);

  if (aggregatedOffers === 0) {
    return null;
  }

  if (isNewbuildingHousesFilterEnabled) {
    return (
      <SummarySection
        leftColumn={
          <>
            <NewbuildingHousesFilterContainer />
            <SummaryHeaderContainer />
          </>
        }
        rightColumn={
          <>
            <SummarySortDropdownContainer />
            <SummaryMapViewButtonContainer />
            <ModerateLinkButtonContainer />
          </>
        }
      />
    );
  }

  return (
    <SummarySection
      leftColumn={
        <>
          <SummaryHeaderContainer />
          <SummarySortDropdownContainer />
          <SummaryMapViewButtonContainer />
        </>
      }
      rightColumn={<ModerateLinkButtonContainer />}
    />
  );
}
